/* G&G Author Payouts page.
   Reads /apps/proxy/api/storefront/authors/payouts and posts withdrawal
   requests to /apps/proxy/api/storefront/authors/request-payout.
   Version: 2026-06-18-apo-r3-amount-cancel */
(function () {
  'use strict';
  try { console.log('[apo] author-payouts.js v2026-06-18-apo-r3-amount-cancel'); } catch (e) {}

  function fmtMoney(a, c) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: c || 'USD' }).format(a || 0); }
    catch (e) { return (a || 0).toFixed(2) + ' ' + (c || ''); }
  }
  // BUSINESS dates are rendered in the SHOP's time zone, never the viewer's.
  //
  // A bare toLocaleDateString() formats in whatever zone the browser sits in,
  // so the same sale showed one day to someone in Kyiv, another in the Shopify
  // admin (which is always shop time) and a third to a buyer in California.
  // The zone travels down in the API payload; until the first response lands we
  // fall back to the viewer's, which is the old behaviour and never worse.
  var SHOP_TZ = null;
  function setShopTz(tz) { if (tz) SHOP_TZ = tz; }
  function dateOpts(o) {
    var out = {};
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = o[k];
    if (SHOP_TZ) out.timeZone = SHOP_TZ;
    return out;
  }
  function fmtDate(iso) { try { return new Date(iso).toLocaleDateString(undefined, dateOpts({ day: 'numeric', month: 'short', year: 'numeric' })); } catch (e) { return iso; } }
  function el(tag, opts) {
    var n = document.createElement(tag);
    if (opts) {
      if (opts.className) n.className = opts.className;
      if (opts.text != null) n.textContent = String(opts.text);
      if (opts.html != null) n.innerHTML = opts.html;
      if (opts.attrs) Object.keys(opts.attrs).forEach(function (k) { n.setAttribute(k, opts.attrs[k]); });
    }
    return n;
  }
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var PAGE_SIZE = 8;

  function init(root) {
    var inner = root.querySelector('.apo-inner');
    if (!inner) return;
    var isPreview = root.dataset.apoPreview === '1';
    if (!isPreview && inner.getAttribute('data-apo-is-author') !== '1') return;

    var els = {
      available: inner.querySelector('[data-apo-available]'),
      awaiting: inner.querySelector('[data-apo-awaiting]'),
      request: inner.querySelector('[data-apo-request]'),
      paypal: inner.querySelector('[data-apo-paypal]'),
      max: inner.querySelector('[data-apo-max]'),
      amount: inner.querySelector('[data-apo-amount]'),
      amountHint: inner.querySelector('[data-apo-amount-hint]'),
      cur: inner.querySelector('[data-apo-cur]'),
      submit: inner.querySelector('[data-apo-submit]'),
      msg: inner.querySelector('[data-apo-msg]'),
      pendingCard: inner.querySelector('[data-apo-pending-card]'),
      pendingAmount: inner.querySelector('[data-apo-pending-amount]'),
      pendingSub: inner.querySelector('[data-apo-pending-sub]'),
      cancel: inner.querySelector('[data-apo-cancel]'),
      cancelMsg: inner.querySelector('[data-apo-cancel-msg]'),
      historyCard: inner.querySelector('[data-apo-history-card]'),
      history: inner.querySelector('[data-apo-history]'),
      meta: inner.querySelector('[data-apo-meta]'),
    };

    var state = { currency: 'USD', min: 50, available: 0, awaiting: 0, payouts: [], page: 1, busy: false, prefilled: false };

    function setMsg(text, tone) {
      if (!els.msg) return;
      els.msg.textContent = text || '';
      els.msg.className = 'apo-msg' + (tone ? ' apo-msg--' + tone : '');
    }

    function curSymbol(c) {
      try { return (0).toLocaleString(undefined, { style: 'currency', currency: c || 'USD' }).replace(/[\d.,\s]/g, '') || '$'; }
      catch (e) { return '$'; }
    }

    // "Withdraw all" just fills the field with the full available balance -
    // the field is always the single source of truth for the amount.
    if (els.max) els.max.addEventListener('click', function () {
      if (!els.amount) return;
      els.amount.value = state.available ? String(Math.round(state.available * 100) / 100) : '';
      updateAmountHint();
    });
    if (els.amount) els.amount.addEventListener('input', updateAmountHint);

    // Custom amount steppers (+/- $1), clamped to 0..available. Replaces the
    // browser's default number spinners (hidden via CSS) for a clean look.
    inner.querySelectorAll('[data-apo-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!els.amount) return;
        var step = parseFloat(b.getAttribute('data-apo-step')) || 0;
        var cur = parseFloat(els.amount.value);
        if (!isFinite(cur)) cur = 0;
        var next = Math.round((cur + step) * 100) / 100;
        if (next < 0) next = 0;
        if (next > state.available) next = state.available;
        els.amount.value = next ? String(next) : '';
        updateAmountHint();
      });
    });

    function updateAmountHint() {
      if (!els.amountHint) return;
      els.amountHint.textContent = 'Min ' + fmtMoney(state.min, state.currency)
        + ' · available ' + fmtMoney(state.available, state.currency) + '.';
    }

    function pendingPayout() {
      for (var i = 0; i < state.payouts.length; i++) {
        if (state.payouts[i].status === 'pending') return state.payouts[i];
      }
      return null;
    }

    function render() {
      if (els.available) els.available.textContent = fmtMoney(state.available, state.currency);
      var pending = pendingPayout();

      if (els.awaiting) {
        if (state.awaiting > 0) {
          els.awaiting.hidden = false;
          els.awaiting.textContent = fmtMoney(state.awaiting, state.currency) + ' reserved in a pending request';
        } else {
          els.awaiting.hidden = true;
        }
      }

      // Pending request -> show the pending card, hide the form (one at a time).
      if (pending) {
        if (els.request) els.request.hidden = true;
        if (els.pendingCard) {
          els.pendingCard.hidden = false;
          if (els.pendingAmount) els.pendingAmount.textContent = fmtMoney(pending.amount, pending.currency || state.currency);
          if (els.pendingSub) {
            var bits = ['Requested ' + fmtDate(pending.createdAt)];
            if (pending.payoutEmail) bits.push('to ' + pending.payoutEmail);
            els.pendingSub.textContent = bits.join(' · ');
          }
        }
      } else {
        if (els.pendingCard) els.pendingCard.hidden = true;
        if (els.request) {
          els.request.hidden = false;
          // Prefill PayPal + currency symbol.
          if (els.paypal && !els.paypal.value && state.paypalEmail) els.paypal.value = state.paypalEmail;
          if (els.cur) els.cur.textContent = curSymbol(state.currency);
          // Prefill the amount with the full balance ONCE (default = withdraw
          // all), but never clobber what the author has typed.
          if (els.amount && !state.prefilled) {
            els.amount.value = state.available ? String(Math.round(state.available * 100) / 100) : '';
            state.prefilled = true;
          }
          // Disable requesting below the minimum.
          var canRequest = state.available >= state.min;
          if (els.submit) els.submit.disabled = !canRequest || state.busy;
          if (!canRequest) setMsg('You need at least ' + fmtMoney(state.min, state.currency) + ' available to request a payout.', 'muted');
          else if (els.msg && els.msg.classList.contains('apo-msg--muted')) setMsg('');
          updateAmountHint();
        }
      }

      renderHistory();

      if (els.meta) {
        var n = state.payouts.length;
        els.meta.textContent = n ? (n + ' payout' + (n === 1 ? '' : 's') + ' total') : 'No payouts yet.';
      }
    }

    function statusBadge(p) {
      var paid = p.status === 'paid';
      return el('span', { className: 'apo-badge ' + (paid ? 'apo-badge--paid' : 'apo-badge--pending'), text: paid ? 'paid' : 'pending' });
    }

    function renderHistory() {
      if (!els.historyCard || !els.history) return;
      var items = state.payouts;
      if (!items.length) { els.historyCard.hidden = true; return; }
      els.historyCard.hidden = false;
      els.history.innerHTML = '';

      var totalPages = Math.max(1, Math.ceil(items.length / PAGE_SIZE));
      if (state.page > totalPages) state.page = totalPages;
      if (state.page < 1) state.page = 1;
      var start = (state.page - 1) * PAGE_SIZE;

      items.slice(start, start + PAGE_SIZE).forEach(function (p) {
        var row = el('div', { className: 'apo-row' });
        var left = el('div', { className: 'apo-row-left' });
        var top = el('div', { className: 'apo-row-top' });
        top.appendChild(el('span', { className: 'apo-row-amount', text: fmtMoney(p.amount, p.currency || state.currency) }));
        top.appendChild(statusBadge(p));
        left.appendChild(top);
        var sub = [];
        if (p.status === 'paid' && p.paidAt) sub.push('Paid ' + fmtDate(p.paidAt));
        else sub.push('Requested ' + fmtDate(p.createdAt));
        if (p.payoutEmail) sub.push(p.payoutEmail);
        if (p.method) sub.push(p.method);
        if (p.reference && p.reference !== 'author-requested') sub.push(p.reference);
        left.appendChild(el('div', { className: 'apo-row-sub', text: sub.join(' · ') }));
        row.appendChild(left);
        els.history.appendChild(row);
      });

      if (totalPages > 1) {
        var pager = el('div', { className: 'apo-pager' });
        pager.appendChild(el('span', { className: 'apo-pager-info', text: 'Page ' + state.page + ' of ' + totalPages }));
        var nav = el('div', { className: 'apo-pager-nav' });
        var prev = el('button', { className: 'apo-pager-btn', text: '‹', attrs: { type: 'button' } });
        prev.disabled = state.page === 1;
        prev.addEventListener('click', function () { state.page--; renderHistory(); });
        var next = el('button', { className: 'apo-pager-btn', text: '›', attrs: { type: 'button' } });
        next.disabled = state.page === totalPages;
        next.addEventListener('click', function () { state.page++; renderHistory(); });
        nav.appendChild(prev); nav.appendChild(next);
        pager.appendChild(nav);
        els.history.appendChild(pager);
      }
    }

    function submit() {
      if (state.busy) return;
      var paypal = els.paypal ? els.paypal.value.trim() : '';
      if (!EMAIL_RE.test(paypal)) { setMsg('Enter a valid PayPal email.', 'error'); if (els.paypal) els.paypal.focus(); return; }

      // The amount field is the single source of truth - whatever's in it is
      // what gets requested (the "Withdraw all" button just fills it for you).
      var amt = parseFloat(els.amount ? els.amount.value : '');
      if (!(amt > 0)) { setMsg('Enter an amount.', 'error'); if (els.amount) els.amount.focus(); return; }
      amt = Math.round(amt * 100) / 100;
      if (amt < state.min) { setMsg('Minimum payout is ' + fmtMoney(state.min, state.currency) + '.', 'error'); return; }
      if (amt > state.available) { setMsg("That's more than your available balance (" + fmtMoney(state.available, state.currency) + ').', 'error'); return; }
      var payload = { paypalEmail: paypal, amount: amt };

      if (isPreview) { setMsg('Preview mode - requests are disabled.', 'muted'); return; }

      state.busy = true;
      if (els.submit) { els.submit.disabled = true; els.submit.classList.add('is-loading'); }
      setMsg('Requesting...', 'muted');

      fetch('/apps/proxy/api/storefront/authors/request-payout', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) { return r.json().then(function (j) { setShopTz(j && j.timeZone); return { ok: r.ok, json: j }; }); })
        .then(function (resp) {
          state.busy = false;
          if (els.submit) els.submit.classList.remove('is-loading');
          if (!resp.ok) { setMsg((resp.json && resp.json.error) || 'Could not request payout.', 'error'); if (els.submit) els.submit.disabled = false; return; }
          setMsg('Requested ' + fmtMoney(resp.json.amount, resp.json.currency || state.currency) + ' - we will process it shortly.', 'ok');
          load(); // refresh balance + history + flip to pending card
        })
        .catch(function (e) {
          state.busy = false;
          if (els.submit) { els.submit.disabled = false; els.submit.classList.remove('is-loading'); }
          setMsg('Could not request payout: ' + e.message, 'error');
        });
    }
    if (els.submit) els.submit.addEventListener('click', submit);

    // Cancel a pending request (mistake guard) - returns the reserved amount
    // to the author's balance. Only the author's own pending payout is touched.
    function cancelRequest() {
      if (state.busy) return;
      if (isPreview) { if (els.cancelMsg) els.cancelMsg.textContent = 'Preview mode - disabled.'; return; }
      var pending = pendingPayout();
      if (!pending) return;
      if (!window.confirm('Cancel this payout request? The amount returns to your available balance.')) return;
      state.busy = true;
      if (els.cancel) els.cancel.disabled = true;
      if (els.cancelMsg) els.cancelMsg.textContent = 'Cancelling...';
      fetch('/apps/proxy/api/storefront/authors/cancel-payout', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ payoutId: pending.id }),
      })
        .then(function (r) { return r.json().then(function (j) { setShopTz(j && j.timeZone); return { ok: r.ok, json: j }; }); })
        .then(function (resp) {
          state.busy = false;
          if (els.cancel) els.cancel.disabled = false;
          if (!resp.ok) { if (els.cancelMsg) els.cancelMsg.textContent = (resp.json && resp.json.error) || 'Could not cancel.'; return; }
          if (els.cancelMsg) els.cancelMsg.textContent = '';
          state.prefilled = false; // re-prefill the form with the restored balance
          load();
        })
        .catch(function (e) {
          state.busy = false;
          if (els.cancel) els.cancel.disabled = false;
          if (els.cancelMsg) els.cancelMsg.textContent = 'Could not cancel: ' + e.message;
        });
    }
    if (els.cancel) els.cancel.addEventListener('click', cancelRequest);

    function apply(d) {
      state.currency = d.currency || 'USD';
      state.min = typeof d.min === 'number' ? d.min : 50;
      state.paypalEmail = d.paypalEmail || '';
      state.available = (d.balance && d.balance.pendingBalance) || 0;
      state.awaiting = (d.balance && d.balance.awaitingPayout) || 0;
      state.payouts = d.payouts || [];
      render();
    }

    function mock() {
      var now = Date.now();
      return {
        currency: 'USD', min: 50, paypalEmail: 'designer@example.com',
        balance: { pendingBalance: 420.5, awaitingPayout: 0, totalPaid: 1860, totalEarned: 2280.5, currency: 'USD' },
        payouts: [
          { id: 'p1', amount: 740, currency: 'USD', status: 'paid', method: 'paypal', payoutEmail: 'designer@example.com', reference: 'PP-A4F2', createdAt: new Date(now - 864e5 * 40).toISOString(), paidAt: new Date(now - 864e5 * 38).toISOString() },
          { id: 'p2', amount: 620, currency: 'USD', status: 'paid', method: 'paypal', payoutEmail: 'designer@example.com', reference: 'PP-9C12', createdAt: new Date(now - 864e5 * 70).toISOString(), paidAt: new Date(now - 864e5 * 68).toISOString() },
        ],
      };
    }

    function load() {
      if (isPreview) { apply(mock()); return; }
      fetch('/apps/proxy/api/storefront/authors/payouts', { credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { setShopTz(j && j.timeZone); return { ok: r.ok, json: j }; }); })
        .then(function (resp) {
          if (!resp.ok) { if (els.meta) els.meta.textContent = (resp.json && resp.json.error) || 'Failed to load payouts.'; return; }
          apply(resp.json);
        })
        .catch(function (e) { if (els.meta) els.meta.textContent = 'Failed to load payouts: ' + e.message; });
    }

    load();
  }

  function boot() {
    document.querySelectorAll('.apo-wrapper').forEach(function (root) {
      if (root.dataset.apoInit === '1') return;
      root.dataset.apoInit = '1';
      init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
